module.exports = __webpack_public_path__ + "img/dots_icon.2e760ad8.svg";